export { PriceTypeModalComponent } from './price-type-modal.component';
